/* hs-eslint ignored failing-rules */

'use es6';

import PropTypes from 'prop-types';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import H2 from 'UIComponents/elements/headings/H2';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import ReportNameField from '../../shared/inputFields/ReportNameField';
import { getName, getId as getReportId } from '../../../data/schemas/reportSchema';
import { useHideDialog } from '../../../dialog/ducks';
import { useMutation } from 'data-fetching-client';
import { RENAME_REPORT } from '../../../data/requests/report';
import { getDefaultSavedReportActionEventProperties } from '../../report-action-wrapper';
import { useTracker } from '../../../utils/hooks/useTracker';
import { EVENTS } from '../../../utils/usageTracker';
import { useUserRoleForReport } from '../../../utils/trackingUtils';
import { useState } from 'react';
import { noop } from '../../shared/noop';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RenameReportModal = ({
  appUsageTracker,
  report,
  onRenameReportSuccess = noop
}) => {
  const hideDialog = useHideDialog();
  const [renameReportMutation] = useMutation(RENAME_REPORT);
  const usageTracker = useTracker(appUsageTracker);
  const reportName = report ? getName(report) : null;
  const [name, setName] = useState(reportName);
  const [validationError, setValidationError] = useState(null);
  const userRole = useUserRoleForReport(report);
  const handleConfirm = () => {
    if (usageTracker) {
      usageTracker.track(EVENTS.completeAssetUpdate, Object.assign({}, getDefaultSavedReportActionEventProperties(report), {
        action: 'rename',
        actionType: 'save',
        object: 'name',
        role: userRole
      }));
    }
    const renamedReport = report.set('name', name);
    renameReportMutation({
      variables: {
        reportId: getReportId(report),
        renamedReport
      }
    }).then(() => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "reporting-action-components.actions.rename.modal.success",
          options: {
            reportName: name
          }
        }),
        type: 'success',
        'data-test-id': 'report-save-success-alert'
      });
      onRenameReportSuccess(renamedReport);
    }, () => ReportActionsFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.rename.modal.failure"
      }),
      type: 'danger'
    })).then(() => {
      hideDialog();
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "report-rename-modal",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: hideDialog
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.rename.modal.message"
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(ReportNameField, {
        reportName: name,
        onChange: setName,
        onValidationError: setValidationError
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UITooltip, {
        disabled: !validationError,
        title: validationError,
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: handleConfirm,
          disabled: !!validationError,
          "data-test-id": "report-save-confirm",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.rename.modal.confirm"
          })
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: hideDialog,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.rename.modal.reject"
        })
      })]
    })]
  });
};
RenameReportModal.propTypes = {
  appUsageTracker: PropTypes.object.isRequired,
  report: PropTypes.object.isRequired,
  onRenameReportSuccess: PropTypes.func
};
export default RenameReportModal;